import { SelectionModel } from '@angular/cdk/collections';
import { AsyncPipe, NgClass, NgIf } from '@angular/common';
import { Component, Input, ViewEncapsulation } from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import {
  MatLegacyDialog as MatDialog,
  MatLegacyDialogModule as MatDialogModule,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';
import {
  MatLegacyTableDataSource as MatTableDataSource,
  MatLegacyTableModule as MatTableModule,
} from '@angular/material/legacy-table';
import { MatToolbarModule } from '@angular/material/toolbar';
import {
  BazisMaterialHelper,
  CuttingButt,
  CuttingSettings,
  MaterialBaseButtsDialogComponent,
  MaterialBaseEdgeDialogData,
} from 'cloud-shared-lib';
import { Observable } from 'rxjs';
import { finalize, tap } from 'rxjs/operators';

@Component({
  templateUrl: './edge-materials-dialog.component.html',
  styleUrls: ['./edge-materials-dialog.component.scss'],
  standalone: true,
  imports: [
    NgIf,
    NgClass,
    AsyncPipe,
    MatToolbarModule,
    MatDividerModule,
    MatDialogModule,
    MatTableModule,
    MatIconModule,
  ],
  encapsulation: ViewEncapsulation.None,
})
export class EdgeMaterialsDialogComponent {
  @Input() cuttingOptions: CuttingSettings;
  @Input() originalThickness = 0;

  selection: SelectionModel<CuttingButt> = new SelectionModel(false, []);

  displayColumns = ['name', 'article', 'thickness'];
  dataSource: MatTableDataSource<CuttingButt> = new MatTableDataSource();

  materialBaseButtsDialogRef: MatDialogRef<MaterialBaseButtsDialogComponent>;

  select$: Observable<CuttingButt>;

  @Input() set edges(val: CuttingButt[]) {
    this.dataSource.data = val;
  }

  constructor(public dialogRef: MatDialogRef<EdgeMaterialsDialogComponent>, public dialog: MatDialog) {}

  openMaterialBaseDialog(): void {
    this.materialBaseButtsDialogRef = this.dialog.open(MaterialBaseButtsDialogComponent, {
      panelClass: 'material-base-butt-list-dialog',
      disableClose: false,
      width: '1000px',
      data: {
        filterByThickness: this.originalThickness,
      } as MaterialBaseEdgeDialogData,
    });

    this.select$ = this.materialBaseButtsDialogRef.afterClosed().pipe(
      tap((result: CuttingButt | undefined) => {
        if (result) {
          this.dialogRef.close([
            {
              name: BazisMaterialHelper.increaseMaterial(result.name, result.article),
              thickness: result.thickness,
              isTape: result.isTape,
              sign: result.sign,
              textureRotationDegree: result.textureRotationDegree,
              textureName: result.textureName,
            } as CuttingButt,
          ]);
        }
      }),
      finalize(() => (this.materialBaseButtsDialogRef = null))
    );
  }
}
